import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Heading, Paragraph } from '@digdir/designsystemet-react';
import type { SafetyRepWork } from '../../../api/safetyRepWork';
import { useMarkNotificationsReadMutation } from '../../../hooks/queries/safetyRep/useSafetyRepWork';
import { NotificationList } from './NotificationList';
import layout from '../../HRDashboard/hmsPage.module.css';
import classes from '../SafetyRep.module.css';

/** The latest notifications. Marking all as read leaves what waits, as tasks are read when they are done. */
export const NotificationsCard = ({
  notifications,
}: {
  notifications: SafetyRepWork['notifications'];
}): ReactElement => {
  const { t } = useTranslation();
  const markRead = useMarkNotificationsReadMutation();
  return (
    <section
      aria-labelledby="vo-notifications"
      className={layout.card}
      data-gap="sm"
    >
      <div className={classes.cardHeading}>
        <Heading level={2} data-size="sm" id="vo-notifications">
          {t('safetyRep.work.notifications.title')}
        </Heading>
        <Paragraph data-size="xs" className={layout.subtle} role="status">
          {notifications.waiting > 0
            ? t('safetyRep.work.notifications.waitingCount', {
                count: notifications.waiting,
              })
            : t('safetyRep.work.notifications.noneWaiting')}
        </Paragraph>
      </div>
      {notifications.latest.length === 0 ? (
        <Paragraph data-size="sm">
          {t('safetyRep.work.notifications.none')}
        </Paragraph>
      ) : (
        <NotificationList notifications={notifications.latest} />
      )}
      {notifications.unread > notifications.waiting && (
        <Button
          variant="tertiary"
          data-size="sm"
          className={classes.inlineAction}
          loading={markRead.isPending}
          onClick={() => markRead.mutate(null)}
        >
          {t('safetyRep.work.notifications.markAll')}
        </Button>
      )}
    </section>
  );
};
